import InviteEmployee from "./Container"

export default InviteEmployee
